import { TaskItem } from '@/entities/task/model/taskTypes'
import { TaskStatusConfig } from './taskTypes'
import { Tag } from '@/shared/ui/components/Tag'

export const getStatusTag = (status: TaskItem['status']) => {
  const config = TaskStatusConfig[status] || TaskStatusConfig.Failed
  return <Tag variant={config.variant}>{config.label}</Tag>
}
